<div class="flex flex-column flex-grow product-card"
     *ngIf="displayed"
     [class.selected]="isSelected"
     (click)="onProductDetails()"
     (keydown.enter)="onProductDetails()"
     tabindex="0">

    <div class="product-top-row flex full-width" [class.has-image]="displayed.image_url">
        <div class="flex product-image" *ngIf="displayed.image_url">
            <img [src]="displayed.image_url" [alt]="displayed.title" />
        </div>

        <div class="flex flex-column align-start full-width product-name" [class.selected]="!displayed.image_url">
            <h4 class="m-0">{{ displayed.title }}</h4>
        </div>

        <div class="flex align-center justify-center product-add-icon" *ngIf="isSelected">
            <i class="fa-solid fa-check" aria-hidden="true"></i>
        </div>
    </div>

    <div class="product-bottom-row flex flex-column flex-grow justify-end full-width">
        <div class="flex justify-start full-width product-description" *ngIf="displayed.description?.length">
            <p class="p2 lvl-1 m-0">
                {{ displayed.description | truncate: descriptionLimit }}
            </p>
        </div>

        <div class="d-flex flex-wrap variant-chips" *ngIf="showColorPicker">
            <button
                type="button"
                *ngFor="let v of variants"
                class="variant-chip"
                [class.active]="displayed.id === v.id"
                [class.locked]="isVariantDisabled(v)"
                [disabled]="isVariantDisabled(v)"
                (click)="onSelectVariant($event, v)"
            >{{ labelFor(v) }}</button>
        </div>

        <div class="flex flex-row justify-between align-end full-width pt-3 mt-auto">
            <div>
                <button *ngIf="showCart" class="button select-button" [class.remove]="isSelected" (click)="onToggle($event)">
                    <div class="flex align-center justify-center icon">
                        <i class="{{ !isSelected ? 'fa-solid fa-shopping-cart' : 'fa-regular fa-trash' }}" aria-hidden="true"></i>
                    </div>
                </button>
            </div>

            <!-- Price & Payment Frequency -->
            <div class="flex flex-column align-end">
                <h3 class="m-0">
                    {{ displayed.price | calculatePaymentWithSale: sale | currency:'USD':'symbol':'1.2-2' }}
                </h3>
                <p class="caption lvl-1 m-0" *ngIf="sale && sale.payment_frequency">
                    {{ sale.payment_frequency | paymentSuffix }}
                </p>
            </div>
        </div>
    </div>
</div>
